import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from '~/hooks';

export default function Tooltip({
  id,
  className,
  text,
  children,
}: {
  id: string;
  text: string;
  className?: string;
  children: React.ReactNode;
}) {
  const { i18n } = useTranslation('app');
  const locale = i18n.language;
  const { mobileScreen } = useBreakpoint();

  if (!text) return null;

  return (
    <>
      <div
        className={`inline-flex cursor-help ${className ?? ''}`}
        data-tip={text}
        data-tooltip-id={id}
        data-tooltip-content={text}
        data-tooltip-place={
          mobileScreen ? 'bottom' : locale === 'ar' ? 'left' : 'right'
        }
      >
        {children}
      </div>
      <ReactTooltip id={id} className={`z-[9999] ${className ?? ''}`} />
    </>
  );
}
